<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
    <rect id="사각형_2269" data-name="사각형 2269" class="cls-1" width="64" height="64" rx="32" transform="translate(0 64) rotate(-90)"/>
    <path id="패스_9584" data-name="패스 9584" class="cls-2" d="M12.48,24.959,0,12.48,12.48,0" transform="translate(19.55 39.545) rotate(-90)"/>
  </svg>
</template>
<script>
export default {
  name: 'IconGo',
  methods: {},
};
</script>
<style scoped>
  .cls-1, .cls-2 {
    fill: none;
  }

  .cls-2 {
    stroke: var(--primary-ft-color);
    stroke-linecap: round;
    stroke-width: 4px;
  }

  .dark .cls-2 {
    stroke: var(--primary-ft-color-dark);
  }
</style>
